import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControlDefinition } from 'src/app/model/form-control-definition';
import { Supplier } from 'src/app/model/supplier';
import { SupplierInterface } from 'src/app/model/supplier-interface';


/**
 * GetTransactionsDialogComponent opens up a dialog for the user to enter
 * a card number.
 */
@Component({
  selector: 'app-get-transactions-dialog-component',
  templateUrl: './get-transactions-dialog.component.html',
  styleUrl: './get-transactions-dialog.component.scss'
})
export class GetTransactionsDialogComponent {
  /** Form group for validation */
  public formGroup: FormGroup = new FormGroup({
    cardNumber: new FormControl("", Validators.required),
  });

  /** The form to render */
  public form: FormControlDefinition[] = [
    {
      title: "Card Number",
      name: "cardNumber",
      type: "number",
      placeholder: "0",
      control: this.formGroup.controls["cardNumber"],
      editable: true,
    }
  ];

  /**
   * Default constructor initializes the component with a dialog ref
   */
  constructor( 
    public dialogRef: MatDialogRef<GetTransactionsDialogComponent>,
  ) {}

  /**
   * Cancel any changes and close the dialog
   */
  public cancel() {
    this.dialogRef.close(null);
  }

  /**
   * Save the changes to a new supplier and close the dialog
   */
  public save() {
    // Get the raw data from the form and convert necessary fields
    const raw: any = this.formGroup.getRawValue();

    // Return the card number
    this.dialogRef.close(raw.cardNumber);
  }
}
